module.exports = __webpack_public_path__ + "static/media/barnes-projetsneufs-noir.6a5bd462.png";